import { Dialog, DialogContent, Divider, Grid, Slide, Typography } from '@mui/material';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { RadioListItem } from 'components/Input/Radio';
import { TextBoxItem } from 'components/Input/TextBox';
import UploadFileItem from 'components/Input/UploadFile';
import { FormProvider } from 'react-hook-form';
import { Extension } from 'utilities/utilities';
import TableReceive from './TableReceive';
import { useReceiveTicketForm } from '../../hooks/useReceiveTicket';
import moment from 'moment';
import { SelectItem } from 'components/Input/Select/SelectItem';
import React from 'react';
import { TransitionProps } from '@mui/material/transitions';

const ReceiveTicketForm = () => {

    const {
        objMuseum,
        isView,
        objParamPath,
        onClearAttachFile,
        arrAttachmentList,
        setArrAttachmentList,
        form,
        gotoBack,
        handleSubmitForm,
        lstMuseum,
        nUserType,
        getTypeTicketMuseum,
        isSaving
    } = useReceiveTicketForm()




    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} >
                    <FormProvider {...form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                {
                                    nUserType === 1 ?
                                        <TextBoxItem
                                            id={"sMuseum"}
                                            name="sMuseum"
                                            label={"ชื่อพิพิธภัณฑ์"}
                                            maxLength={250}
                                            required={nUserType === 1}
                                            type={'text'}
                                            disabled
                                        />
                                        :
                                        <SelectItem
                                            id={"nMuseum"}
                                            name={"nMuseum"}
                                            label={`ชื่อพิพิธภัณฑ์`}
                                            required={nUserType !== 1}
                                            options={lstMuseum}
                                            disabled={objParamPath.ParamId != null}
                                            onChange={(eValue) => {
                                                let nMuseumId = eValue ? eValue.value : null;
                                                getTypeTicketMuseum(nMuseumId, null, null)
                                            }}
                                        />
                                }
                            </Grid>
                            <Grid item xs={12} >
                                <RadioListItem
                                    id={"sInCentral"}
                                    name={"sInCentral"}
                                    label={`การทำรับจากการจัดซื้อ ใช้เงินจากกองทุนจัดการซากดึกดำบรรพ์ หรือไม่?`}
                                    required={true}
                                    disabled={isView}
                                    options={[
                                        { value: "1", label: "ใช่" },
                                        { value: "0", label: "ไม่" }
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextBoxItem
                                    name="sOrderBook"
                                    label={"เลขที่ใบสั่งซื้อ"}
                                    maxLength={10}
                                    id={"sOrderBook"}
                                    required={true}
                                    disabled={isView}
                                    type={'text'}
                                    IsShowTextCont
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePickerItem
                                    name={"dRecieveTicket"}
                                    id={"dRecieveTicket"}
                                    label={`วันที่รับตั๋ว`}
                                    fullWidth={true}
                                    required={true}
                                    disabled={isView || objParamPath.ParamId != null}
                                    maxDate={moment()}
                                    onChange={(eValue) => {
                                        let dReceive = eValue ? moment(eValue).valueOf() : null;
                                        getTypeTicketMuseum(objMuseum.nMuseumID, objMuseum.sMuseumName, dReceive)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <UploadFileItem
                                    id="upFile"
                                    name={"upFile"}
                                    key={"upFile"}
                                    label='เอกสารแนบ'
                                    arrFile={arrAttachmentList}
                                    setarrFile={setArrAttachmentList}
                                    IsFolder={false}
                                    IsMultiple={false}
                                    Extension={Extension.FileTicketZip}
                                    nLimitFile={30}
                                    sLimitFile={"MB"}
                                    onClearFile={onClearAttachFile}
                                    modeDisplay={"list"}
                                    sFolderTemp={"Receive"}
                                    sPositionText={"right"}
                                    required={false}
                                    disabled={isView}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <br />
                            </Grid>
                            <Grid item xs={12} >
                                <Typography>หน่วยเป็น : เล่ม</Typography>
                                <Divider />
                            </Grid>

                            <Grid item xs={12} >
                                <TableReceive form={form} isEdit={objParamPath.ParamId != null} nMuseumID={objMuseum.nMuseumID}/>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>
                <Grid item xs={12} >

                </Grid>

                <Grid item xs={12} >
                    <Grid container spacing={2} justifyContent={"center"} alignItems={"start"}>
                        <Grid item>
                            <BtnBack id={"btnback-temp-email"} onClick={() => gotoBack()} />
                        </Grid>
                       {!isView && <Grid item>
                            <BtnSave id={"btnsave-temp-email"} onClick={form.handleSubmit(handleSubmitForm)} />
                        </Grid>}
                    </Grid>
                </Grid>
            </Grid>
            <Dialog
                // open={true}
                open={isSaving}
                TransitionComponent={Transition}
                keepMounted
            >
                <DialogContent>
                    <div className='loader'></div>
                    <Typography color={"#002168"} fontSize={"1.5em"} fontWeight={700} textAlign={"center"}>โปรดรอสักครู่ ระบบกำลังดำเนินการบันทึกข้อมูล</Typography>
                    <Typography color={"#757575"} fontSize={"1em"} fontWeight={500} textAlign={"center"}>กรุณาอย่าปิดหน้านี้ จนกระทั่งบันทึกรายการสำเร็จ!</Typography>
                </DialogContent>
            </Dialog>
        </>

    )
}

export default ReceiveTicketForm

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
